const REGEX = {
  IS_EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  IS_MOBILE_NO: /^\+?\d{1,3}?[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
  IS_NOT_A_NUMBER: /^[^\d]+$/,
  IS_ALPHABETIC: /^[a-zA-Z\s]+$/
};

export const isEmail = (email: any) => REGEX.IS_EMAIL.test(email);
export const isMobileNo = (mobile: any) => REGEX.IS_MOBILE_NO.test(mobile);
export const isNotANumber = (val: any) => REGEX.IS_NOT_A_NUMBER.test(val);
export const isAlphabtetic = (val: any) => REGEX.IS_ALPHABETIC.test(val);
export const isAbnValid = (value: any) => {
  if (!value) return false; // required
  if (!/^\d+$/.test(value)) return false; // numeric only
  return true;
};



export const cashdCurrentUser = () => ({
  token: localStorage.getItem("serviceToken"),
});
